import React, { useState } from 'react';

import { AiField } from 'components/ai/field';
import { Textarea } from '@buildoutinc/blueprint-react/ui/Textarea';
import { ButtonGroup } from '@buildoutinc/blueprint-react/ui/ButtonGroup';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';

import { Button } from 'components/ui/button';

import PanelFooter from './panel_footer';
import { CALL_RESULTS } from './config';

interface Props {
  aiEnabled?: boolean;
  collapseKey?: string;
  parentId?: number;
  parentType?: string;
  purpose: string;
  callResult?: string;
  date: Date;
  placeholder: string;
  saving: boolean;
  value: string;
  onCallResultChange: (result: string) => void;
  onChange: (value: string) => void;
  onDateChange: (date: Date) => void;
  onSubmit: () => void;
}

export default function CallPanel({
  aiEnabled,
  collapseKey,
  parentId,
  parentType,
  purpose,
  callResult,
  date,
  placeholder,
  saving,
  value,
  onCallResultChange,
  onChange,
  onDateChange,
  onSubmit,
}: Props) {
  const [generating, setGenerating] = useState(false);

  return (
    <div className="d-flex flex-column gap-3">
      <AiField
        aiEnabled={Boolean(aiEnabled && parentId && parentType)}
        collapseKey={collapseKey}
        context={{ parentId, parentType, purpose }}
        feature="Activity body"
        value={value}
        onChange={onChange}
        onGeneratingChange={setGenerating}
      >
        {({ className, generating }) => (
          <Textarea
            className={className}
            placeholder={placeholder}
            readOnly={generating}
            rows={4}
            value={value}
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
          />
        )}
      </AiField>

      <ButtonGroup>
        {CALL_RESULTS.map((result) => {
          const selected = callResult === result.key;
          return (
            <Button
              icon={selected ? faCheck : null}
              key={result.key}
              variant={selected ? 'primary' : 'outline'}
              onClick={() => onCallResultChange(selected ? '' : result.key)}
            >
              {result.label}
            </Button>
          );
        })}
      </ButtonGroup>

      <PanelFooter
        buttonLabel="Log Call"
        date={date}
        disabled={generating || !value.trim()}
        saving={saving}
        showDate={Boolean(value.trim())}
        onDateChange={onDateChange}
        onSubmit={onSubmit}
      />
    </div>
  );
}
